// modules
import React, { Fragment, useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'modules/Stores';
// components
import { View, Divider, Link } from '@upstox/upstox-ui';
import Modal from 'app/components/MainLayout/components/Modal';
// services
import LocaleService from 'modules/Localization';
// constants
import { ENV } from 'config';
import { EXTERNAL_LINKS } from 'app/routing/registration';

const ImportantLinksModal = () => {
  const {
    toggleModal,
    modalsConfig: { importantLinks },
  } = useStore('AppStore');

  const conditionsRef = useRef<HTMLAnchorElement>(null);
  const odrPortalRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (odrPortalRef.current) {
      // setting the target as _blank using ref,
      // becuase the ui package accepts the target prop but doesnot apply it to the "a" tag.
      odrPortalRef.current.target = '_blank';
    }
    if (conditionsRef.current) {
      conditionsRef.current.target = '_blank';
    }
  }, [importantLinks]);

  const onClose = () => {
    toggleModal('importantLinks');
  };

  return importantLinks ? (
    <Modal onClose={onClose} title="Important links">
      <View as="div" flexDirection="column" gap="medium" margin={['large', 8]}>
        <View as="div" gap="medium" margin={['small', 'xlarge']}>
          <Link
            href={EXTERNAL_LINKS.TERMS_AND_CONDITIONS[ENV]}
            rel="noopener noreferrer"
            as="a"
            tabIndex={-1}
            ref={conditionsRef}
            onClick={onClose}
          >
            {LocaleService.translate('TERMS_AND_CONDITIONS')}
          </Link>
        </View>
        <View as="div" gap="medium" margin={['small', 'xlarge']}>
          <Link
            href={EXTERNAL_LINKS.ODR_PORTAL_LINK[ENV]}
            rel="noopener noreferrer"
            as="a"
            tabIndex={-1}
            ref={odrPortalRef}
            onClick={onClose}
          >
            {LocaleService.translate('SEBI_ODR_PORTAL')}
          </Link>
        </View>
      </View>
      <Divider />
    </Modal>
  ) : (
    <Fragment />
  );
};

export default observer(ImportantLinksModal);
